import { Typography } from "antd";

const Gallery = () => (<Typography.Title level={2}>Coming Soon</Typography.Title>);

export default Gallery;
